export class AvailableFacetManager {
  constructor(map) {
    this.map = map
  }

  static empty() {
    return new AvailableFacetManager({});
  }

  static fromQueryResult(response) {
    const map = response.FacetResults?.reduce((map, facetResult) => {
      const key = facetResult.DocumentAttributeKey;
      const value = facetResult.DocumentAttributeValueCountPairs;

      if (key && value) {
        map[key] = value;
      }

      return map;
    }, {})

    if (map) {
      return new AvailableFacetManager(map);
    } else {
      return AvailableFacetManager.empty();
    }
  }

  setAll(
    availableFacets
  ){
    return new AvailableFacetManager(availableFacets);
  }

  set(
    attributeName,
    values
  ) {
    return new AvailableFacetManager({
      ...this.map,
      [attributeName]: values,
    });
  }

  get(attributeName) {
    if (this.map.hasOwnProperty(attributeName)) {
      return this.map[attributeName];
    } else {
      return [];
    }
  }

  /*
   * Get all the available attribute names in natural sort order
   */
  getAvailableAttributeNames() {
    return Object.keys(this.map).sort();
  }
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/facets/AvailableFacetManager.js